module.exports = __webpack_public_path__ + "static/media/Niveau_elN9_1_631027.50afef8b.png";